import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const DownloadIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M19.1205 10.1719L12.8348 16.1719C12.3732 16.6125 11.6268 16.6125 11.1701 16.1719L4.87946 10.1719C4.41786 9.73125 4.41786 9.01875 4.87946 8.58281C5.34107 8.14688 6.0875 8.14219 6.5442 8.58281L10.8165 12.6609V1.125C10.8165 0.501562 11.342 0 11.9951 0C12.6482 0 13.1737 0.501562 13.1737 1.125V12.6609L17.446 8.58281C17.9076 8.14219 18.654 8.14219 19.1107 8.58281C19.5674 9.02344 19.5723 9.73594 19.1107 10.1719H19.1205ZM3.35714 16.125V19.875C3.35714 20.9109 4.23616 21.75 5.32143 21.75H18.6786C19.7638 21.75 20.6429 20.9109 20.6429 19.875V16.125C20.6429 15.5016 21.1683 15 21.8214 15C22.4746 15 23 15.5016 23 16.125V19.875C23 22.1531 21.0652 24 18.6786 24H5.32143C2.93482 24 1 22.1531 1 19.875V16.125C1 15.5016 1.52545 15 2.17857 15C2.8317 15 3.35714 15.5016 3.35714 16.125Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default DownloadIcon
